"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@apollo/client/core");
const utils_1 = require("./utils");
const helpers_1 = require("../helpers");
// An extension of the Apollo client that add support for watching updates to entities
// and collections of entities based on the provided filters.
class ApolloExtensionsClient extends core_1.ApolloClient {
    constructor(config) {
        super(config);
        // @ts-ignore
        this.policies = this.cache.policies;
    }
    // Watches the data in the cache similarly to watchQuery and additionally extracts the given fieldName from the watch query
    // subscription and returns a subscription that emits that field data.
    watchQueryForField(query, fieldName) {
        const obsQuery = this.watchQuery({
            fetchPolicy: 'cache-only',
            query: query,
        });
        const subscribe = obsQuery.subscribe.bind(obsQuery);
        obsQuery.subscribe = (observer, ...rest) => {
            // This check is modeled after the Zen Observable observer check:
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L211
            if (typeof observer !== 'object') {
                observer = {
                    next: observer,
                    error: rest[0],
                    complete: rest[1],
                };
            }
            const observerNext = observer.next;
            // The observer maps the value emitted from the observable to the data at the
            // given field name.
            observer.next = (value) => {
                var _a;
                if (observerNext) {
                    observerNext((_a = value === null || value === void 0 ? void 0 : value.data) === null || _a === void 0 ? void 0 : _a[fieldName]);
                }
            };
            const subscription = subscribe(observer);
            const unsubscribe = subscription.unsubscribe.bind(subscription);
            subscription.unsubscribe = () => {
                // @ts-ignore typePolicies is private. Delete the field name from the type policies
                // after the subscription has been cleaned up.
                delete this.cache.policies.typePolicies.Query.fields[fieldName];
                unsubscribe();
            };
            return subscription;
        };
        return obsQuery;
    }
    // Watches the data in the cache similarly to watchQuery for a given fragment.
    watchFragment(options) {
        const fieldName = (0, helpers_1.generateFragmentFieldName)();
        const query = (0, utils_1.buildWatchFragmentQuery)(Object.assign(Object.assign({}, options), { fieldName, policies: this.policies }));
        return this.watchQueryForField(query, fieldName);
    }
    // Watches the data in the cache similarly to watchQuery for all entities int he cache
    // matching the given filter.
    watchFragmentWhere(options) {
        const fieldName = (0, helpers_1.generateFragmentFieldName)();
        const filterVar = (0, core_1.makeVar)(options.filter);
        const limitVar = (0, core_1.makeVar)(options.limit);
        const orderByVar = (0, core_1.makeVar)(options.orderBy);
        const query = (0, utils_1.buildWatchFragmentWhereQuery)(Object.assign(Object.assign({}, options), { fieldName,
            filterVar,
            limitVar,
            orderByVar, cache: this.cache, policies: this.policies }));
        return this.watchQueryForField(query, fieldName);
    }
}
exports.default = ApolloExtensionsClient;
//# sourceMappingURL=ApolloExtensionsClient.js.map